(() => {
  const rootSelector = ".kaching-icon-block";
  const titleSelector = "span.kaching-icon-block--icon-title";
  const observers = new Map();

  function convertTitles(scope) {
    if (scope.nodeType !== 1) return;
    const titles = scope.matches(titleSelector)
      ? [scope]
      : scope.querySelectorAll(titleSelector);
    for (const title of titles) {
      const heading = document.createElement("h3");
      for (const attribute of title.attributes) {
        heading.setAttribute(attribute.name, attribute.value);
      }
      while (title.firstChild) heading.appendChild(title.firstChild);
      title.replaceWith(heading);
    }
  }

  function initialize(scope) {
    const roots = scope.nodeType === 1 && scope.matches(rootSelector)
      ? [scope]
      : scope.querySelectorAll(rootSelector);
    for (const root of roots) {
      const container = root.closest(".shopify-app-block") || root;
      if (observers.has(container)) continue;
      convertTitles(container);
      const observer = new MutationObserver((records) => {
        for (const record of records) {
          for (const node of record.addedNodes) convertTitles(node);
        }
      });
      observer.observe(container, { childList: true, subtree: true });
      observers.set(container, observer);
    }
  }

  document.addEventListener("shopify:section:load", (event) => {
    initialize(event.target);
  });
  document.addEventListener("shopify:section:unload", (event) => {
    for (const [container, observer] of observers) {
      if (event.target.contains(container)) {
        observer.disconnect();
        observers.delete(container);
      }
    }
  });
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
})();
